import { render } from "./driver-comment.vue?vue&type=template&id=3c25a7c2"
import script from "./driver-comment.vue?vue&type=script&lang=js"
export * from "./driver-comment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__